module.exports = __webpack_public_path__ + "static/img/banner_logo.b32f64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/banner_logo.png
// module id = 5UYh
// module chunks = 13